import { generateUserAccessListForQuery, } from "@buildwithflux/models";
/**
 * Determines if the current user has permission to clone a document to a given destination
 *
 * The logic here is similar to the doesUserHavePermissionToCloneDocument() function, but the differences are:
 *  - This function receives all the user's memberships, not just the relevant ones
 *  - This function works on an ISearchDocumentData object, not the fully hydrated IDocument<IDocumentData>,
 *     so it can't check the roles collection at all.
 *
 * This function previously also used to check whether the user was an owner of the owning organization or enterprise,
 * and disallowed cloning if they weren't, the document was private, and the destinationOrganizationUid was a different
 * organization. That logic has been disabled after FLUX-5209, but remains in case we want to reintroduce it for
 * enterprises in the future.
 *
 * @param document The document targeted for cloning/forking
 * @param currentUser The current user that wants to do the clone/fork
 * @param memberships All of the current user's organization memberships (including enterprise ones).
 * @param _destinationOrganizationUid The organization that the user is trying to clone the document into, if there is
 *     one (undefined implies cloning to current user account)
 * @param _destinationEnterpriseUid The enterprise that the user is trying to clone the document into, if there is one
 *     (undefined implies EITHER cloning to current user account, or cloning to a non-enterprise organization)
 * @see https://linear.app/buildwithflux/issue/FLUX-5209/always-allow-cloning-and-forking-of-projects-you-can-view
 */
export function doesUserHavePermissionToCloneSearchDocument(document, currentUser, memberships, _destinationOrganizationUid, _destinationEnterpriseUid) {
    /*
     * This logic that checked the document whether the document was able to be cloned out of the owning organization
     * or enterprise was disabled after FLUX-5209. It remains in case we want to re-enable it later for enterprises.
     *
     * const docOwnerOrganizationMember = memberships.find(
     *     (membership) => membership.organizationUid === document.organization_owner_uid,
     * );
     * const docOwnerEnterpriseMember = memberships.find(
     *     (membership) => membership.enterpriseUid === document.enterprise_owner_uid,
     * );
     *
     * const notPublic = !document.userAccessList.includes(ANON_ROLE_UID);
     *
     * // Org owned but public documents can be cloned anywhere
     * if (document.organization_owner_uid && notPublic) {
     *     // But, for org-private documents
     *
     *     if (!docOwnerOrganizationMember && docOwnerEnterpriseMember?.role !== "owner") {
     *         // Non-org-members can't clone at all
     *         return false;
     *     }
     *
     *     if (
     *         docOwnerOrganizationMember?.role !== "owner" &&
     *         docOwnerEnterpriseMember?.role !== "owner" &&
     *         (destinationOrganizationUid !== document.organization_owner_uid ||
     *             destinationEnterpriseUid !== document.enterprise_owner_uid)
     *     ) {
     *         // Non-owners can only clone to the same organization and enterprise
     *         return false;
     *     }
     *
     *     // Organization and enterprise owners can clone anywhere, including to their personal accounts
     * }
     */
    const accessList = generateUserAccessListForQuery(currentUser.uid, memberships);
    for (const userWithAccess of accessList) {
        if ((document.userAccessList ?? []).includes(userWithAccess)) {
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=policies.js.map